const formatCallTypes = (value) => {
    let callType = '';

    switch(value){
        case 1:
            callType = 'INCOMING';
            break;

        case 2:
            callType = 'OUTGOING';
            break;

        case 3:
            callType = 'MISSED';
            break;
        
        case 4:
            callType = 'VOICEMAIL';
            break;

        case 5:
            callType = 'REJECTED';
            break;

        case 6:
            callType = 'BLOCKED';
            break;

        case 7:
            callType = 'ANSWERED_EXTERNALLY_TYPE';
            break;

        default:
            console.error('Call type not supported');
    };

    return callType;
}

export {formatCallTypes};